const decodeToMarkDown = (message_rich: string | null) => {
  if (!message_rich) {
    return ""
  }

  return message_rich.replace(/<data:image\/png;base64,([^>]+)data:image\/png;>/g, (_, base64Data) => {
    return `![](data:image/png;base64,${base64Data})`
  })
}

export default decodeToMarkDown
